/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable } from '@angular/core';
import { SearchableProvider } from '../model/interface/searchable.provider';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RestResponse,  Position } from '../model';
import { environment } from '../../environments/environment';
import { ApiHeaders } from './headers';

@Injectable()
export class PositionProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) {
  }

  getPositions(page: number, query?: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/position/list?page=${page}${query ? '&query=' + encodeURIComponent(query) : ''}`,
        ApiHeaders.getOptions());
  }

  getPosition(id: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/position/${id}`, ApiHeaders.getOptions());
  }

  savePosition(position: Position): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/position`, position, ApiHeaders.getOptions());
  }

  deletePosition(id: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/position/${id}/delete`, null, ApiHeaders.getOptions());
  }

  // --------- Inherited From SearchableProvider --------------- //

  getSearchType(): string {
    return 'POSITION';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return undefined;
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return this.getPositions(page ? page : 1, query);
  }
}
